/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 403:
/***/ (() => {

// Add passive event to improve performance
// https://developer.mozilla.org/fr/docs/Web/API/EventTarget/addEventListener#Am%C3%A9lioration_des_performances_de_d%C3%A9filement_avec_les_%C3%A9couteurs_passifs
window.supportPassive = false;

try {
  window.addEventListener(
    'test',
    null,
    Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get() {
        window.supportPassive = { passive: false };
      },
    })
  );
} catch (err) {
  // eslint-disable-next-line no-console
  console.log('SupportPassive si not supported with this browser.');
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";

;// ./src/js/CheckboxTermsCart.js
class CheckboxTermsCart {
  constructor() {
    this.formSelector = '.cart-form-js';
    this.checkBoxSelector = '#checkbox-terms-cond-cart';
    this.submitSelector = '.cart-form-js button[type="submit"]';
    this.checkBoxLabel = '.checkbox-terms-cart__label';
    this.cartDrawerSelector = '.cart-drawer';
  }

  init() {
    this.manageCheckBox();

    window.addEventListener('variant:add', () => {
      this.manageCheckBox();
    });

    window.addEventListener('cart:change', () => {
      this.manageCheckBox();
    });

    const cartDrawer = document.querySelector(this.cartDrawerSelector);
    if (!cartDrawer) return;

    cartDrawer.addEventListener('toggle', () => {
      if (cartDrawer.open) {
        this.manageCheckBox();
      }
    });
  }

  manageCheckBox = () => {
    const forms = document.querySelectorAll(this.formSelector);
    if (!forms.length > 0) return;

    forms.forEach((form) => {
      const checkbox = form.querySelector(this.checkBoxSelector);
      const submitButton = form.querySelector(this.submitSelector);
      const checkboxLabel = form.querySelector(this.checkBoxLabel);

      if (!checkbox || !submitButton || !checkboxLabel) return;

      if (localStorage.getItem('cgvChecked') === 'true') {
        checkbox.checked = true;
        submitButton.removeAttribute('disabled');
      }

      // Delete old eventListener for avoid errors
      checkboxLabel.removeEventListener('click', this.handleCheckboxLabelClick);
      checkbox.removeEventListener('change', this.handleCheckboxChange);

      checkboxLabel.addEventListener('click', this.handleCheckboxLabelClick);
      checkbox.addEventListener('change', this.handleCheckboxChange);
    });
  };

  handleCheckboxLabelClick = (e) => {
    if (e.target.tagName !== 'A') {
      e.preventDefault();
      const checkbox = e.currentTarget
        .closest(this.formSelector)
        .querySelector(this.checkBoxSelector);
      const submitButton = e.currentTarget
        .closest(this.formSelector)
        .querySelector(this.submitSelector);

      if (checkbox.checked) {
        checkbox.checked = false;
        submitButton.setAttribute('disabled', '');
        localStorage.setItem('cgvChecked', 'false');
      } else {
        checkbox.checked = true;
        submitButton.removeAttribute('disabled');
        localStorage.setItem('cgvChecked', 'true');
      }
    }
  };

  handleCheckboxChange = (e) => {
    const checkbox = e.target;
    const submitButton = checkbox
      .closest(this.formSelector)
      .querySelector(this.submitSelector);

    if (checkbox.checked) {
      submitButton.removeAttribute('disabled');
      localStorage.setItem('cgvChecked', 'true');
    } else {
      submitButton.setAttribute('disabled', '');
      localStorage.setItem('cgvChecked', 'false');
    }
  };
}

;// ./src/js/CollectionDescription.js
class CollectionDescription {
  collectionDescription = null;
  collectionDescriptionButton = null;

  init() {
    this.collectionDescription = document.querySelector(
      '.collection__description-excerpt'
    );

    this.collectionDescriptionButton = document.querySelector(
      '.collection__description-button'
    );

    if (this.collectionDescription && this.collectionDescriptionButton) {
      this.toggleButtonContent();
      this.collectionDescriptionButton.addEventListener('click', () => {
        this.toggleExcerpt();
      });
    }
  }

  toggleExcerpt = () => {
    this.collectionDescription.classList.toggle(
      'collection__description-excerpt--hidden'
    );

    this.toggleButtonContent();
  };

  toggleButtonContent = () => {
    const buttonContent =
      this.collectionDescriptionButton.getElementsByTagName('span');
    if (
      this.collectionDescription.classList.contains(
        'collection__description-excerpt--hidden'
      )
    ) {
      buttonContent[1].style.display = 'none';
      buttonContent[0].style.display = 'inline-block';
    } else {
      buttonContent[0].style.display = 'none';
      buttonContent[1].style.display = 'inline-block';
    }
  };
}

;// ./src/js/FaibrikChat.js
class FaibrikChat {
  constructor() {
    this.shadowHostSelector = '#faibrik-chat-shadow-host';
    this.widgetSelector = '#faibrik-chat-widget';
    this.observer = null;
  }

  init = () => {
    this.observeDom();
  };

  observeDom = () => {
    this.observer = new MutationObserver(() => {
      this.tryApplyStyle();
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    this.tryApplyStyle();
  };

  tryApplyStyle = () => {
    const host = document.querySelector(this.shadowHostSelector);
    if (!host || !host.shadowRoot) return;

    const widget = host.shadowRoot.querySelector(this.widgetSelector);
    if (!widget) return;

    widget.style.width = 'fit-content';

    this.disconnectObserver();
  };

  disconnectObserver = () => {
    if (!this.observer) return;

    this.observer.disconnect();
    this.observer = null;
  };
}

// EXTERNAL MODULE: ./src/js/helpers.js
var helpers = __webpack_require__(403);
;// ./src/js/PreorderProduct.js
class PreorderProduct {
  constructor() {
    this.initialDeliverySelector = '.product-info .delivery-widget__auto';
    this.offerPreOrderTitleSelector =
      '.product-info .offer--pre-order .offer__title';
  }

  init = () => {
    this.offerPreOrderTitle = document.querySelector(
      this.offerPreOrderTitleSelector
    );
    if (!this.offerPreOrderTitle) return;

    this.initialDelivery = document.querySelector(this.initialDeliverySelector);
    if (!this.initialDelivery) return;

    this.currentVariantIsPreorder(window.currentVariant);

    document.addEventListener('variant:change', (e) => {
      this.currentVariantIsPreorder(e.detail.variant.id);
    });
  };

  currentVariantIsPreorder = (variantId) => {
    const isPreorder = window.variantPreorder[variantId].preorder ?? false;
    const title = isPreorder
      ? window.variantPreorder[variantId].title
      : window.defaultOfferTitle;

    if (isPreorder) {
      this.initialDelivery.style.display = 'none';
    } else {
      this.initialDelivery.style.display = 'block';
    }

    if (this.offerPreOrderTitle.textContent !== title) {
      this.offerPreOrderTitle.textContent = title;
    }
  };
}

;// ./src/js/product.js
class Product {
  init() {
    this.product = document.querySelector('.product-info');
    if (this.product) {
      this.detectUnavailableProduct();
    }
  }

  detectUnavailableProduct() {
    let submitButton = this.product.querySelector(
      '.buy-buttons button[type="submit"]'
    );
    if (submitButton) {
      if (submitButton.classList.contains('button--subdued') !== true) {
        this.hideButton();
      }
    }

    let switchers = this.product.querySelectorAll('.color-swatch');
    for (let switcher of switchers) {
      switcher.addEventListener('click', () => {
        if (
          switcher.classList.contains('color-swatch--not-available') !== true
        ) {
          this.hideButton();
        } else {
          this.revealButton();
        }
      });
    }
  }

  hideButton() {
    const bisTrigger = this.product.querySelector('#BIS_trigger');
    if (bisTrigger) {
      bisTrigger.style.display = 'none';
    }
  }

  revealButton() {
    const bisTrigger = this.product.querySelector('#BIS_trigger');
    if (bisTrigger) {
      bisTrigger.style.display = 'block';
    }
  }
}

;// ./src/js/ProductCard.js
class ProductCard {
  constructor() {
    this.productCardsSelector = '.product-card';
    this.swatchButtonsSelector = '.product-card__swatch-list .color-swatch';
    this.buttonSelector =
      '.product-card__quick-buy .product-card__desktop-quick-buy-button > div:first-child';
    this.badgeSelector = '.product-card__badge-list .badge--preorder';
  }

  init = () => {
    const productCards = document.querySelectorAll(this.productCardsSelector);
    if (!productCards.length > 0) return;

    productCards.forEach((productCard) => {
      const swatchButtons = productCard.querySelectorAll(
        this.swatchButtonsSelector
      );
      if (!swatchButtons.length > 0) return;

      const button = productCard.querySelector(this.buttonSelector);
      const badge = productCard.querySelector(this.badgeSelector);
      if (!button && !badge) return;

      swatchButtons.forEach((swatchButton) => {
        swatchButton.addEventListener('click', () => {
          const isPreorder = swatchButton.dataset.vsblPreorder === 'true';
          const showPreorderBadge =
            swatchButton.dataset.vsblPreorderBadge === 'true';

          if (button) {
            button.textContent = isPreorder
              ? window.themeVariables.strings.preOrderButton
              : window.themeVariables.strings.addToCartButton;
          }

          if (badge) {
            badge.hidden = !showPreorderBadge;
          }
        });
      });
    });
  };
}

;// ./src/js/ProductInfoDescription.js
class ProductInfoDescription {
  constructor() {
    this.menuSelector = 'header';
    this.descriptionSelector = '.product-info__description';
    this.descriptionContainerSelector = '.prose';
    this.descriptionContent = '';
    this.firstH2Index = '';
    this.accordionElements = '';
    this.accordion = '';
    this.accordionClass = 'product-info__description-accordion';
    this.accordionSectionClass = 'product-info__description-accordion-section';
    this.accordionHeaderClass = 'product-info__description-accordion-header';
    this.accordionTitleClass = 'product-info__description-accordion-title';
    this.accordionButtonClass = 'product-info__description-accordion-button';
    this.accordionContentClass =
      'product-info__description-accordion-content hidden';
    this.accordionSectionSelector =
      '.product-info__description-accordion-section';
    this.accordionHeaderSelector =
      '.product-info__description-accordion-header';
    this.accordionButtonSelector =
      '.product-info__description-accordion-button';
    this.accordionContentSelector =
      '.product-info__description-accordion-content';
  }

  init = () => {
    this.menu = this.getElement(document, this.menuSelector);
    this.description = this.getElement(document, this.descriptionSelector);
    if (!this.description) return;
    this.descriptionContainer = this.getElement(
      this.description,
      this.descriptionContainerSelector
    );
    if (!this.descriptionContainer) return;
    this.descriptionContent = Array.from(this.descriptionContainer.children);
    if (!this.descriptionContent) return;
    this.firstH2Index = this.findFirstH2Index();
    if (!this.firstH2Index) return;
    this.accordionElements = this.getAccordionElements();
    this.createAccordion();
    this.showDescription();
    this.initAccordion();
  };

  initAccordion = () => {
    const accordionSections = this.getElements(
      this.accordion,
      this.accordionSectionSelector
    );
    accordionSections.forEach((section) => {
      const header = this.getElement(section, this.accordionHeaderSelector);
      const button = this.getElement(header, this.accordionButtonSelector);
      const content = this.getElement(section, this.accordionContentSelector);
      header.addEventListener('click', () => {
        this.toggleContent(section, content, button);
      });
    });
  };

  toggleContent = (section, content, button) => {
    if (content.classList.contains('hidden')) {
      this.closeAllContent();
      this.openContent(content, button);
      section.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    } else {
      this.closeContent(content, button);
    }
  };

  closeAllContent = () => {
    const accordionSections = this.getElements(
      this.accordion,
      this.accordionSectionSelector
    );
    accordionSections.forEach((section) => {
      const content = this.getElement(section, this.accordionContentSelector);
      const button = this.getElement(section, this.accordionButtonSelector);
      this.closeContent(content, button);
    });
  };

  closeContent = (content, button) => {
    content.classList.add('hidden');
    button.textContent = '+';
  };

  openContent = (content, button) => {
    content.classList.remove('hidden');
    button.textContent = '-';
  };

  getElements = (cible, selector) => {
    return cible.querySelectorAll(selector) || null;
  };

  showDescription = () => {
    this.descriptionContainer.appendChild(this.accordion);
  };

  createAccordion = () => {
    this.accordion = document.createElement('div');
    this.accordion.className = this.accordionClass;
    let currentSection = null;
    let headerSection = null;
    let headerButton = null;
    let currentDiv = null;
    this.accordionElements.forEach((element) => {
      if (element.tagName === 'H2') {
        if (currentSection) {
          if (currentDiv) {
            currentSection.appendChild(currentDiv);
            currentDiv = this.createDiv(this.accordionContentClass);
          }
          this.accordion.appendChild(currentSection);
        }
        currentSection = this.createDiv(this.accordionSectionClass);
        headerSection = this.createDiv(this.accordionHeaderClass);
        element.className = this.accordionTitleClass;
        headerSection.appendChild(element);
        headerButton = this.createButton();
        headerSection.appendChild(headerButton);
        currentSection.appendChild(headerSection);
      } else {
        if (!currentDiv) {
          currentDiv = this.createDiv(this.accordionContentClass);
        }
        currentDiv.appendChild(element);
      }
    });
    if (currentSection) {
      if (currentDiv) {
        currentSection.appendChild(currentDiv);
      }
      this.accordion.appendChild(currentSection);
    }
  };

  createButton = () => {
    const button = this.createDiv(this.accordionButtonClass);
    button.textContent = '+';
    return button;
  };

  createDiv = (className) => {
    const div = document.createElement('div');
    div.className = className;
    return div;
  };

  getAccordionElements = () => {
    return this.descriptionContent.slice(this.firstH2Index);
  };

  getIntro = () => {
    return this.descriptionContent.slice(0, this.firstH2Index);
  };

  findFirstH2Index = () => {
    return (
      this.descriptionContent.findIndex(
        (element) => element.tagName === 'H2'
      ) || null
    );
  };

  getElement = (cible, selector) => {
    return cible.querySelector(selector) || null;
  };
}

;// ./src/js/ProductQuickAddMobile.js
class ProductQuickAddMobile {
  constructor() {
    this.productSelector = '.product';
    this.mainButtonSelector = '.buy-buttons__wrapper';
    this.quickAddButtonSelector = '.product-quick-add';
  }

  init = () => {
    const productPage = document.querySelector(this.productSelector);
    if (!productPage) return;

    const mainButton = productPage.querySelector(this.mainButtonSelector);
    this.quickAddButton = document.querySelector(this.quickAddButtonSelector);

    if (!mainButton || !this.quickAddButton) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          mainButton.style.display = 'block';
          this.quickAddButton.classList.add('product-quick-add--hide');
        } else {
          this.quickAddButton.classList.add('product-quick-add--show');
          this.quickAddButton.classList.remove('product-quick-add--hide');
        }
      });
    });

    observer.observe(mainButton);

    this.detectVariantChange();
  };

  detectVariantChange = () => {
    document.addEventListener('variant:change', (event) => {
      const currentVariantAvailable = event.detail.variant.available;

      if (currentVariantAvailable) {
        this.quickAddButton.classList.add('product-quick-add--available');
      } else {
        this.quickAddButton.classList.remove('product-quick-add--available');
      }
    });
  };
}

;// ./src/js/QuickBuy.js
class QuickBuy {
  constructor() {
    this.quickBuySelector = '.quick-buy-drawer__info';
    this.addToCartButtonSelector = '.buy-buttons__add-to-cart';
  }

  init = () => {
    document.addEventListener('variant:change', (e) => {
      this.handleQuickBuyElement(e.detail.variant.id);
    });
  };

  handleQuickBuyElement = (variantId) => {
    const isPreorder = window.variantPreorder[variantId].preorder ?? false;

    const quickBuy = document.querySelector(this.quickBuySelector);
    if (!quickBuy) return;

    const buttonText = quickBuy.querySelector(
      `${this.addToCartButtonSelector} div`
    );
    if (!buttonText) return;

    if (isPreorder) {
      buttonText.textContent = window.themeVariables.strings.preOrderButton;
    } else {
      buttonText.textContent = window.themeVariables.strings.addToCartButton;
    }
  };
}

;// ./src/js/VariantPicker.js
class VariantPicker {
  constructor() {
    this.variantPickerSelector = '.product-info__variant-picker';
    this.optionValuesInputSelector =
      '.variant-picker__option-values input[type="radio"]';
  }

  init = () => {
    this.variantPicker = document.querySelector(this.variantPickerSelector);
    if (!this.variantPicker) return;

    this.optionsValuesInputs = this.variantPicker.querySelectorAll(
      this.optionValuesInputSelector
    );
    if (!this.optionsValuesInputs.length) return;

    document.addEventListener('variant:change', (event) => {
      const currentPicker = document.querySelector(this.variantPickerSelector);
      if (!currentPicker) return;

      const options2Inputs = Array.from(
        currentPicker.querySelectorAll(this.optionValuesInputSelector)
      ).filter((input) => input.dataset.optionPosition === '2');

      // If variant isnt exist, select the first valid option2 & hide the invalid ones
      if (!event.detail.variant) {
        const selected = options2Inputs.find((input) => {
          const label = currentPicker.querySelector(`label[for="${input.id}"]`);
          return label && !label.classList.contains('is-disabled');
        });
        if (selected) {
          options2Inputs.forEach((input) => {
            input.checked = input === selected;
          });
          selected.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  };
}

;// ./src/main.js


// JS goes here












window.addEventListener(
  'load',
  () => {
    const globalComponents = [
      new Product(),
      new CollectionDescription(),
      new CheckboxTermsCart(),
      new PreorderProduct(),
      new QuickBuy(),
      new ProductCard(),
      new ProductQuickAddMobile(),
      new ProductInfoDescription(),
      new FaibrikChat(),
      new VariantPicker(),
    ];

    globalComponents.forEach((component) => component.init());
  },
  window.supportPassive
);

})();

/******/ })()
;